import type { ColumnFiltersState, PaginationState, SortingState } from '@tanstack/react-table'
import type { ListParams } from '../../api/listApi.types'
import type { ColumnDefinition } from './types'

export function sortingToApiSort<TRow = unknown>(
  sorting: SortingState,
  columns?: ColumnDefinition<TRow>[],
): { sort_by?: string; order?: 'asc' | 'desc' } {
  const first = sorting[0]
  if (!first) return {}
  const col = columns?.find((c) => c.id === first.id)
  return {
    sort_by: col?.sortKey ?? first.id,
    order: first.desc ? 'desc' : 'asc',
  }
}

export function apiSortToSorting<TRow = unknown>(
  sort?: { sort_by: string; order: 'asc' | 'desc' },
  columns?: ColumnDefinition<TRow>[],
): SortingState {
  if (!sort?.sort_by) return []
  const col = columns?.find(
    (c) => c.sortKey === sort.sort_by || c.id === sort.sort_by,
  )
  return [{ id: col?.id ?? sort.sort_by, desc: sort.order === 'desc' }]
}

export function tableStateToListParams<TRow = unknown>(args: {
  pagination: PaginationState
  sorting: SortingState
  columnFilters: ColumnFiltersState
  search: string
  columns?: ColumnDefinition<TRow>[]
}): ListParams {
  const { pagination, sorting, columnFilters, search, columns } = args
  const filters: Record<string, unknown> = {}

  for (const f of columnFilters) {
    if (f.id === 'search') continue
    if (f.value === undefined || f.value === '' || f.value === false) continue
    if (Array.isArray(f.value) && f.value.length === 0) continue
    const col = columns?.find((c) => c.id === f.id)
    const apiKey = col?.filterKey ?? f.id
    filters[apiKey] = f.value
  }

  const { sort_by, order } = sortingToApiSort(sorting, columns)

  return {
    page: pagination.pageIndex + 1,
    limit: pagination.pageSize,
    search: search.trim() || undefined,
    filters: Object.keys(filters).length ? filters : undefined,
    sort_by,
    order,
  }
}
